<template>
  <div>
    <el-popover
      placement="top"
      trigger="hover"
      popper-class="dark"
    >
      <pre v-if="isCommunityFeaturePermission">點擊進入<br>快速領取</pre>
      <div v-else>
        尚無權限
      </div>
      <div
        v-if="$isServiceEnabled(49) || $isServiceEnabled(48)"
        slot="reference"
        :class="['fab-button', isCommunityFeaturePermission ? '' : 'disabled']"
        @click="openMethodSelDialog"
      >
        <div class="oc">
          <span>快速</span>
          <span>領取</span>
        </div>
      </div>
    </el-popover>

    <el-dialog
      id="methodSelDialog"
      class="KNS-dialog"
      :visible.sync="methodSelDialog"
      width="900px"
      center
    >
      <span
        slot="title"
        class="dialog-title"
      >
        <div class="title-bar">
          <span class="title">請選擇驗證方式</span>
        </div>
      </span>
      <div class="way-select">
        <ul>
          <li @click="selectBarcode">
            <img
              src="../assets/img/Barcode/barcode.png"
              alt="新增裝置"
            >
            <h3>手機條碼</h3>
          </li>
          <li @click="selectedNFC">
            <img
              src="../assets/img/NFC/nfc.png"
              alt="新增載具"
            >
            <h3>門禁卡、磁扣</h3>
          </li>
          <li @click="householdSwitch=true">
            <img
              src="../assets/img/Tablet/choice_tablet.png"
              alt="新增裝置"
            >
            <h3>直接選擇戶別</h3>
          </li>
        </ul>
      </div>
    </el-dialog>

    <el-dialog
      id="oneClickDialog"
      class="KNS-OneClick"
      :visible.sync="oneClickDialog"
      center
      fullscreen
      @close="closeOneClickDialog"
    >
      <div class="top-wrap">
        <div class="tablet-wrap">
          <span class="title">快速領取</span>
          <span
            v-if="tablet.length>0"
            class="tabletNote"
          >
            {{ tablet[0].tablet_note }}
            <span v-if="tablet.length>1">...</span>
          </span>
        </div>
        <ul class="btn-wrap">
          <li
            v-if="$isServiceEnabled(49)"
            :class="[oneClickTab == 'postal' ? 'active':'','btn']"
            @click="oneClickTab='postal'"
          >
            郵務
            <span class="count">{{ postalList.length }}</span>
          </li>
          <li
            v-if="$isServiceEnabled(48)"
            :class="[oneClickTab == 'collection' ? 'active':'','btn']"
            @click="oneClickTab='collection'"
          >
            寄放
            <span class="count">{{ collectionList.length }}</span>
          </li>
        </ul>
      </div>
      <el-tabs v-model="oneClickTab">
        <el-tab-pane
          label="郵務"
          name="postal"
          class="tab-body"
        >
          <div class="note-wrap">
            <div class="noteInput">
              <span class="title">領取備註</span>
              <input
                v-model="postalNoteText"
                class="note"
                type="text"
                placeholder="限30字元"
                maxlength="30"
              >
            </div>
            <div class="noteSample">
              <span class="title">插入範本訊息：</span>
              <span class="sample-wrap">
                <el-popover
                  v-for="(note,note_ind) in noteSample"
                  :key="note_ind"
                  placement="top"
                  trigger="hover"
                  content="點擊插入備註"
                  popper-class="dark"
                >
                  <span
                    slot="reference"
                    @click="postalNoteText=note"
                  >{{ note }}</span>
                </el-popover>
              </span>
            </div>
          </div>
          <div class="list-wrap">
            <div class="title-bar">
              <h3>包裹/郵件未領列表</h3>
              <el-button
                size="small"
                @click="$refs.postalListTable.clearSelection()"
              >
                清除選擇
              </el-button>
              <el-button
                size="small"
                @click="filterPackage"
              >
                快搜包裹條碼
              </el-button>
            </div>
            <div class="list">
              <el-table
                ref="postalListTable"
                :data="postalList"
                border
                style="width: 100%"
                class="KNSDialogTable"
                @selection-change="postalListSelectionChange"
              >
                <el-table-column
                  type="selection"
                  width="60"
                  :selectable="postalSelectable"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      :disabled="postalSelectable(scope.row)"
                      content="無法領取已入櫃包裹"
                      placement="top"
                    >
                      <template #content>
                        <div class="tooltip-content">
                          <div>無法選取已入櫃包裹</div>
                          <div v-if="isShowingLockerUserGuide">
                            點擊查看
                            <a href="https://www.smartdaily.com.tw/pick-up-parcel/" target="_blank" style="color: #409EFF; text-decoration: underline;">
                              如何為住戶領取已入櫃包裹？
                            </a>
                          </div>
                        </div>
                      </template>
                      <span>
                        <el-checkbox
                          v-model="scope.row.selected"
                          :disabled="!postalSelectable(scope.row)"
                          @change="toggleRow(scope.row)"
                        ></el-checkbox>
                      </span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="serial_num"
                  label="編號"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span class="serial_num">{{ scope.row.serial_num }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="收件戶別/收件人"
                  width="300"
                >
                  <template slot-scope="scope">
                    <div>{{ scope.row.tabletNote }}</div>
                    <div>{{ scope.row.p_name }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="postalType"
                  label="收件類型"
                  width="200"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.postalType }}</span>
                    <span
                      v-if="scope.row.is_refrigerated == 1"
                      class="tag refrigeration"
                    >冷藏</span>
                    <span
                      v-if="scope.row.is_refrigerated == 2"
                      class="tag freezing"
                    >冷凍</span>
                    <span
                      v-if="scope.row.smartLockerStatus == 2"
                      class="tag inLocker"
                    >已入櫃</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="create_date"
                  label="登記時間"
                  width="130"
                >
                  <template slot-scope="scope">
                    <span>{{ formatDate(scope.row.create_date) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="transport_code"
                  label="條碼"
                  width="130"
                >
                  <template slot-scope="scope">
                    <el-popover
                      placement="top"
                      trigger="hover"
                      :content="scope.row.transport_code"
                      popper-class="dark"
                    >
                      <span
                        slot="reference"
                      >{{ scope.row.transport_code.length>7 ? `...${scope.row.transport_code.slice(-7)}`:scope.row.transport_code }}</span>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="date"
                  label="位置"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.p_note.indexOf("位置") > -1 ? scope.row.p_note.substr(scope.row.p_note.indexOf("位置") + 3):'' }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="p_note"
                  label="備註"
                  min-width="130"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.p_note.indexOf("位置") > -1 ? scope.row.p_note.substr(0,scope.row.p_note.indexOf("【位置")):scope.row.p_note }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="寄放"
          name="collection"
          class="tab-body"
        >
          <div class="note-wrap">
            <div class="noteInput">
              <span class="title">領取備註</span>
              <input
                v-model="collectionNoteText"
                class="note"
                type="text"
                placeholder="限30字元"
                maxlength="30"
              >
            </div>
            <div class="noteSample">
              <span class="title">插入範本訊息：</span>
              <span class="sample-wrap">
                <el-popover
                  v-for="(note,note_ind) in noteSample"
                  :key="note_ind"
                  placement="top-end"
                  trigger="hover"
                  content="點擊插入備註"
                  popper-class="dark"
                >
                  <span
                    slot="reference"
                    @click="collectionNoteText = note"
                  >{{ note }}</span>
                </el-popover>
              </span>
            </div>
          </div>
          <div class="list-wrap">
            <div class="title-bar">
              <h3>寄放未領列表</h3>
            </div>
            <div class="list">
              <el-table
                ref="collectionListTable"
                :data="collectionList"
                border
                style="width: 100%"
                class="KNSDialogTable"
                @selection-change="collectionListSelectionChange"
              >
                <el-table-column
                  prop="date"
                  type="selection"
                  width="60"
                />
                <el-table-column label="#" width="90">
                  <template
                    slot-scope="scope"
                  >
                    {{ scope.row.serial_num != '' && scope.row.serial_num != null ? 'B' + scope.row.serial_num : '' }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="tabletNote"
                  label="寄放人"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.colTabletNote != null">
                      <span>{{ scope.row.colTabletNote }}</span>
                      <span
                        v-if="scope.row.col_userName != ''"
                        style="display: block"
                      >{{ `【${scope.row.col_userName}】` }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="tabletNote"
                  label="領取人"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.payTabletNote != null">
                      <span>{{ scope.row.payTabletNote }}</span>
                      <span
                        v-if="scope.row.col_payUserName != ''"
                        style="display: block"
                      >{{ `【${scope.row.col_payUserName}】` }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="tabletNote"
                  label="寄放類型"
                >
                  <template slot-scope="scope">
                    {{ scope.row.col_typeDetail == 8 ? '現金' : '非現金' }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="tabletNote"
                  label="寄放細項"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.col_typeDetail == 8 ? scope.row.col_money : scope.row.colTypeDetail }}</span>
                    <span
                      v-if="scope.row.col_type == 1"
                      class="tag refrigeration"
                    >冷藏</span>
                    <span
                      v-if="scope.row.col_type == 2"
                      class="tag freezing"
                    >冷凍</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="colTime"
                  label="登記時間"
                  width="130"
                />
                <el-table-column
                  prop="col_location"
                  label="位置"
                />
                <el-table-column
                  prop="col_note"
                  label="備註"
                />
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer">
        <el-button
          v-if="signPadAuth"
          :class="[sign!= ''?'active':'']"
          icon="icon-sign"
          @click="signPad"
        >
          點擊啟動簽名板
        </el-button>
        <el-button
          type="primary"
          @click="sendData"
        >
          確定領取
        </el-button>
      </div>
    </el-dialog>

    <hosuehold-frame
      :open.sync="householdSwitch"
      type="KNS-HK"
      @select-household="selectedHousehold"
    />
    <SignPad ref="signpad" />
    <reader ref="reader" />
    <repeatedOpeningDialog ref="repeatedDialog" />
    <webcam
      ref="webcam"
      :fixed="true"
      :onside="true"
      @takephoto="takephoto"
    />
  </div>
</template>

<script>
import RepeatedOpeningDialog from '@/components/RepeatedOpeningDialog'
import householdFrame from '@/components/HouseholdFrame'
import ReadNFCBarcode from '@/components/ReadNFCBarcode'
import SignPad from '@/components/SignPad'
import WebCam from '@/components/WebCam'
import getSignPadAuth from '@/components/Mixins/getSignPadAuth'
export default {
  components: {
    'hosuehold-frame': householdFrame,
    reader: ReadNFCBarcode,
    SignPad,
    repeatedOpeningDialog: RepeatedOpeningDialog,
    webcam: WebCam
  },
  mixins: [getSignPadAuth],
  data () {
    return {
      postalNoteText: '',
      collectionNoteText: '',
      noteSample: ['貨到付款，找零0元', '單純現金收付，找零0元'],
      oneClickTab: 'postal', // 快速領取目前頁面
      methodSelDialog: false, // 驗證方式
      householdSwitch: false, // 戶別選單
      oneClickDialog: false, // 快速領取頁面
      tablet: [], // 住戶資訊
      postalList: [], // 郵務列表
      postalSelectionList: [], // 以選取郵務結單列表
      collectionList: [], // 寄放列表
      collectionSelectionList: [], // 以選取寄放結單列表
      sign: '', // 簽名板
      photo: '', // 影像紀錄
      userId: '', // 掃描裝置領取紀錄使用者ID
      NFCCode: '',
      barCode: '',
      isCommunityFeaturePermission: false, // 是否有權限點選快速領取
      signPadAuth: false, // 社區是否開啟簽名板功能
      isSmartLockerCommunity: false, // 社區是否有智慧櫃合約社區
      isShowingLockerUserGuide: true // 2024-10-09 只是為了馥華城真 不要顯示link
    }
  },
  watch: {
    oneClickDialog (now_val) {
      if (!now_val) {
        this.$refs.webcam.closeWebcam()
      }
    },
    methodSelDialog (now_val) {
      if (now_val) {
        this.reSetDefaultValue()
      }
    }
  },
  mounted () {
    this.getCommunityFeaturePermission()
  },
  methods: {
    async getCommunityFeaturePermission () {
      try {
        const url = `${process.env.VUE_APP_MVC_URL}/Login/CommunityFeaturePermission`
        const res = await axios(url, {
          method: 'GET',
          params: {
            communityFeature: 'postal',
            cookies: this.$getCookie('comLoginToken').replace('token=', '')
          }
        })
        this.isCommunityFeaturePermission = res.data.Data
      } catch (error) {
        console.error(error)
      }
    },
    getAllData () { // 取得戶別結單資訊
      const loginUserInfo = localStorage.getItem('loginUserInfo')
      const comId = loginUserInfo ? JSON.parse(loginUserInfo)?.ComId : null
      if (comId === '23032103') {
        // 馥華城真社區 先關閉操作連結
        this.isShowingLockerUserGuide = false
      }
      return new Promise((resolve, reject) => {
        const vobj = this
        this.postalList = []
        this.postalSelectionList = []
        this.collectionList = []
        this.collectionSelectionList = []
        this.sign = ''
        this.postalNoteText = ''
        this.collectionNoteText = ''

        const loading = this.$loading({
          lock: true,
          text: '資料讀取中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let tabletStr = ''
        this.tablet.forEach((val, ind) => {
          tabletStr += val.tablet_id
          // eslint-disable-next-line eqeqeq
          if (this.tablet.length - 1 != ind) {
            tabletStr += ','
          }
        })
        const postal = new Promise((resolve, reject) => {
          const data = [{ condition: [{ name: 'a', val: '2' }] }]
          data[0].condition.push({
            name: 'b',
            val: tabletStr
          })
          const url = process.env.NODE_ENV === 'development' ? '/house/getPostalList' : `${process.env.VUE_APP_WS_URL}/getPostalList`
          const formdata = new FormData()
          formdata.append('jsonStr', JSON.stringify(data))
          axios(url, {
            method: 'POST',
            data: formdata,
            headers: {
              'content-type': 'application/x-www-form-urlencoded',
              'cache-control': 'no-cache'
            }
          }).then(res => {
            // eslint-disable-next-line eqeqeq
            if (res.data.list != '[]') {
              this.postalList = JSON.parse(res.data.list)
            }
            if (res.data.isSmartLockerCommunity === 'True') {
              this.isSmartLockerCommunity = true
            }
            resolve()
          }).catch(err => {
            reject()
          })
        })

        const collection = new Promise((resolve, reject) => {
          const data = [{ condition: [{ name: 'a', val: '0' }] }]
          data[0].condition.push({
            name: 'b',
            val: tabletStr
          })
          const url = process.env.NODE_ENV === 'development' ? '/house/getCollection_v3' : `${process.env.VUE_APP_WS_URL}/getCollection_v3`
          const formdata = new FormData()
          formdata.append('jsonStr', JSON.stringify(data))
          axios(url, {
            method: 'POST',
            data: formdata,
            headers: {
              'content-type': 'application/x-www-form-urlencoded',
              'cache-control': 'no-cache'
            }
          }).then(res => {
            // eslint-disable-next-line eqeqeq
            if (res.data.list != '[]') {
              this.collectionList = JSON.parse(res.data.list)
              console.log(this.collectionList)
            }
            resolve()
          }).catch(err => {
            reject()
          })
        })

        Promise.all([postal, collection]).then(() => {
          // eslint-disable-next-line eqeqeq
          if (this.postalList.length == 0 && this.collectionList.length == 0) {
            loading.close()
            let tabletNoteText = ''
            this.tablet.forEach((val, ind) => {
              // eslint-disable-next-line eqeqeq
              if (ind == this.tablet.length - 1) {
                tabletNoteText += val.tablet_note
              } else {
                tabletNoteText += val.tablet_note + '，'
              }
            })
            console.log(this.tablet)
            this.$alert(`此住戶${tabletNoteText}<br>沒有包裹及寄放物品！`, '', {
              confirmButtonText: '確定',
              dangerouslyUseHTMLString: true,
              callback: action => {
                this.oneClickDialog = false
              }
            })
          } else {
            this.$refs.webcam.init().then(() => {
              setTimeout(() => {
                vobj.$refs.webcam.getPicture()
                next()
                loading.close()
              }, 1000)
            }, () => { loading.close(); next() })
            function next () {
              vobj.oneClickDialog = true
              vobj.$nextTick(() => {
                if (vobj.postalList.length > 0) {
                  vobj.$refs.postalListTable.clearSelection()
                  const allInLocker = vobj.postalList.every(item => item.smartLockerStatus === 2)
                  if (allInLocker) {
                    // 檢查是否所有包裹都已入櫃，都是入櫃包裹則不全選
                    return
                  }
                  const hasSmartLockerPackage = vobj.postalList.some(item => item.smartLockerStatus === 2)
                  if (!hasSmartLockerPackage) {
                    // 沒有已入櫃包裹，全選
                    vobj.$refs.postalListTable.toggleAllSelection()
                  } else {
                    // 有已入櫃包裹，只選擇不在櫃體裡的包裹
                    vobj.postalList.forEach((item) => {
                      if (item.hasSmartLocker !== 2) {
                        vobj.$refs.postalListTable.toggleRowSelection(item, true)
                      }
                    })
                  }
                }
              })
            }
          }
          resolve()
        }).catch(err => {
          console.log(err)
        })
      })
    },
    selectedHousehold (res) { // 選擇戶別結單
      this.tablet = [res]
      this.householdSwitch = false
      this.NFCCode = ''
      this.barCode = ''
      this.getAllData()
    },
    selectedNFC () { // 選擇感應扣結單
      // this.methodSelDialog=false
      this.$refs.reader.getCode((code) => {
        this.NFCCode = code
        const url = process.env.NODE_ENV === 'development' ? '/house/getCarrierInfo' : `${process.env.VUE_APP_WS_URL}/getCarrierInfo`
        const formdata = new FormData()
        formdata.append('code', code)
        axios(url, {
          method: 'POST',
          data: formdata,
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'cache-control': 'no-cache'
          }
        }).then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.data.list == 'error_noData') {
            this.$alert('此裝置尚未開通。', '', {
              confirmButtonText: '確定',
              callback: action => {
                this.$refs.reader.close()
              }
            })
            this.NFCCode = ''
          } else {
            this.barCode = ''
            const fcnInfo = JSON.parse(res.data.list)
            if (fcnInfo.length >= 2) {
              this.$refs.repeatedDialog.alert(fcnInfo, callback => {
                this.tablet = []
                if (callback.length > 0) {
                  callback.forEach(val => {
                    this.tablet.push({
                      tablet_id: val.tablet_id,
                      tablet_note: val.tabletNote
                    })
                  })
                  this.getAllData()
                  this.$refs.reader.close()
                } else {
                  this.$refs.reader.close()
                }
              }, 'receive')
            } else {
              this.tablet = [{
                tablet_id: fcnInfo[0].tablet_id,
                tablet_note: fcnInfo[0].tabletNote
              }]
              this.getAllData()
              this.$refs.reader.close()
            }
          }
        }).catch(err => {
        })
      }, {
        type: 'NFC',
        model: 'basic',
        title: '請將載具放在感應區',
        subtitle: '門禁卡、磁扣、悠遊卡、一卡通等'
      })
    },
    selectBarcode () { // 選擇掃描至生活條碼結單
      // this.methodSelDialog=false
      this.$refs.reader.getCode((code) => {
        this.barCode = code
        const url = process.env.NODE_ENV === 'development' ? '/house/getDeviceInfo' : `${process.env.VUE_APP_WS_URL}/getDeviceInfo`
        const formdata = new FormData()
        formdata.append('code', code)
        axios(url, {
          method: 'POST',
          data: formdata,
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'cache-control': 'no-cache'
          }
        }).then(res => {
          console.log(res)
          // eslint-disable-next-line eqeqeq
          if (res.data.list == 'error_noData') {
            this.$alert('此裝置尚未開通。', '警告', {
              type: 'warning',
              confirmButtonText: '確定',
              callback: action => {
                this.$refs.reader.close()
              }
            })
            this.barCode = ''
          // eslint-disable-next-line eqeqeq
          } else if (res.data.status == 'error_valid') {
            this.$alert('條碼驗證錯誤，請洽技術中心！', '錯誤', {
              type: 'error',
              confirmButtonText: '確定',
              callback: action => {
                this.$refs.reader.close()
              }
            })
            this.barCode = ''
          } else {
            this.NFCCode = ''
            this.tablet = []
            const fcnInfo = JSON.parse(res.data.list)
            this.userId = fcnInfo[0].user_id
            fcnInfo.forEach(val => this.tablet.push({ tablet_id: val.tablet_id, tablet_note: val.tabletNote }))
            this.getAllData()
            this.$refs.reader.close()
          }
        }).catch(err => {

        })
      }, 'Barcode')
    },
    postalListSelectionChange (val) { // 郵務列表勾選後的回調函式
      this.postalSelectionList = val.filter((item) => item.smartLockerStatus !== 2)
      this.initSelections()
    },
    collectionListSelectionChange (val) { // 寄放列表勾選後的回調函式
      this.collectionSelectionList = val
    },
    signPad () { // 啟動簽名板
      this.$refs.signpad.getSign(res => {
        this.sign = res
      })
    },
    takephoto (url) { // WebCam拍照後回調函式
      this.photo = url
    },
    sendData () { // 確定領取Btn
      const vobj = this
      // eslint-disable-next-line eqeqeq
      if (vobj.oneClickTab == 'postal' && this.postalSelectionList.length == 0) {
        this.$alert('未勾選欲領取物品！', '', {
          confirmButtonText: '確定',
          callback: action => { }
        })
        return false
      // eslint-disable-next-line eqeqeq
      } else if (vobj.oneClickTab == 'collection' && this.collectionSelectionList.length == 0) {
        this.$alert('未勾選欲領取物品！', '', {
          confirmButtonText: '確定',
          callback: action => { }
        })
        return false
      }

      // eslint-disable-next-line eqeqeq
      if (this.signPadAuth && this.sign == '') {
        this.$confirm('是否繼續完成領取?', '尚未簽名', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          next()
        }).catch(() => {
        })
      } else {
        next()
      }

      function next () {
        console.log(vobj.oneClickTab)
        // eslint-disable-next-line eqeqeq
        if (vobj.oneClickTab == 'postal') {
          vobj.checkOutPostal()
        // eslint-disable-next-line eqeqeq
        } else if (vobj.oneClickTab == 'collection') {
          vobj.checkOutcollection()
        }
      }
    },
    uploadAllFile (fileName) { // 上傳簽名檔&WebCam
      return new Promise((resolve, reject) => {
        const vobj = this
        const retrunData = {
          handwriteUri: '',
          webcamUri: ''
        }
        const uploadSign = new Promise((resolve, reject) => {
          // eslint-disable-next-line eqeqeq
          if (vobj.sign != '') {
            vobj.$base64Decode(vobj.sign, bs64 => {
              vobj.$uploadFileToFirebase({ file: bs64, folder: 'handwrite', fileName }, img_url => {
                // eslint-disable-next-line eqeqeq
                if (img_url != 'error') {
                  console.log(img_url)
                  retrunData.handwriteUri = img_url
                  resolve()
                } else {
                  reject()
                }
              })
            })
          } else {
            resolve()
          }
        })

        const uploadWebcam = new Promise((resolve, reject) => {
          // eslint-disable-next-line eqeqeq
          if (vobj.photo != '') {
            vobj.$base64Decode(vobj.photo, bs64 => {
              vobj.$uploadFileToFirebase({ file: bs64, folder: 'webcam', fileName }, img_url => {
                // eslint-disable-next-line eqeqeq
                if (img_url != 'error') {
                  console.log(img_url)
                  retrunData.webcamUri = img_url
                  resolve()
                } else {
                  reject()
                }
              })
            })
          } else {
            resolve()
          }
        })

        Promise.all([uploadSign, uploadWebcam]).then(() => {
          resolve(retrunData)
        }, () => {
          reject()
        })
      })
    },
    checkOutPostal () { // 郵務結單
      const loading = this.$loading({
        lock: true,
        text: '資料傳送中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let receiveType // 取件類型  0:手機 1:簽名 2:感應 3:直接
      // eslint-disable-next-line eqeqeq
      if (this.NFCCode != '') // 感應扣領取 = 感應
      // eslint-disable-next-line eqeqeq
      { receiveType = 2 } else if (this.barCode != '') // 不是感應扣也不是選戶 = 手機
      // eslint-disable-next-line eqeqeq
      { receiveType = 0 } else if (this.sign != '') // 選戶 且 有簽名 = 簽名
      { receiveType = 1 } else // 選戶 且 沒簽名 = 直接
      { receiveType = 3 }

      const apiData = {
        user: this.userId,
        fileName: new Date().getTime().toString(),
        webcamUri: '',
        handwriteUri: '',
        postalReceiveNote: this.postalNoteText,
        // eslint-disable-next-line eqeqeq
        isMobile: receiveType == 2 && this.NFCCode !== '' ? 'true' : 'false',
        // eslint-disable-next-line eqeqeq
        isPluginRule: this.sign == '' ? 'false' : 'true',
        PostalIdList: this.postalSelectionList.map(val => { return val.pd_id }),
        // eslint-disable-next-line eqeqeq
        MobileCode: receiveType == 0 ? this.barCode : '',
        // eslint-disable-next-line eqeqeq
        CarrierlCode: receiveType == 2 ? this.NFCCode : '',
        receiveType
      }

      this.uploadAllFile(apiData.fileName).then((res) => {
        apiData.handwriteUri = res.handwriteUri
        apiData.webcamUri = res.webcamUri
        console.log(apiData)
        const url = process.env.NODE_ENV === 'development' ? '/localmvc/Postal/EndPostal' : `${process.env.VUE_APP_MVC_URL}/Postal/EndPostal`
        axios(url, {
          method: 'POST',
          data: apiData,
          headers: {
            'content-type': 'application/json; charset=utf-8',
            'cache-control': 'no-cache'
          }
        }).then(res => {
          loading.close()
          console.log(res.data.Data)
          // eslint-disable-next-line eqeqeq
          if (res.data.Data && res.data.Status == 1) {
            this.$alert('領取成功。', '', {
              confirmButtonText: '確定',
              callback: action => {
                this.getAllData()
                this.$emit('updateHeaderCount')
              }
            })
          } else if (res.ErrorMessage && res.ErrorMessage.Code === 400) {
            loading.close()
            this.$alert(res.ErrorMessage.Description || '執行失敗，請洽技術人員。', '', {
              confirmButtonText: '確定',
              callback: action => { }
            })
          } else {
            loading.close()
            this.$alert('執行失敗，請洽技術人員。', '', {
              confirmButtonText: '確定',
              callback: action => { }
            })
          }
        }).catch(err => {
          loading.close()
          this.$alert('執行失敗，請洽技術人員。', '', {
            confirmButtonText: '確定',
            callback: action => { }
          })
        })
      }, () => {
        loading.close()
        this.$alert('執行失敗，請洽技術人員。', '', {
          confirmButtonText: '確定',
          callback: action => { }
        })
      })
    },
    checkOutcollection () { // 郵務結單
      const loading = this.$loading({
        lock: true,
        text: '資料傳送中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const apiData = {
        carrier: this.NFCCode,
        fileName: new Date().getTime().toString(),
        handwriteUri: '',
        keyinCode: this.barCode,
        list: JSON.stringify(this.collectionSelectionList.map(val => { return { id: val.id } })),
        note: this.collectionNoteText,
        tablet: this.tablet[0].tablet_id,
        type: 1,
        user: this.userId,
        webcamUri: ''
      }

      this.uploadAllFile(apiData.fileName).then((res) => {
        apiData.handwriteUri = res.handwriteUri
        apiData.webcamUri = res.webcamUri
        const url = process.env.NODE_ENV === 'development' ? '/house/submitOneClick' : `${process.env.VUE_APP_WS_URL}/submitOneClick`
        const formdata = new FormData()
        formdata.append('jsonStr', JSON.stringify([apiData]))
        axios(url, {
          method: 'POST',
          data: formdata,
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'cache-control': 'no-cache'
          }
        }).then(res => {
          loading.close()
          let errMsg = ''
          switch (res.data.status) {
          case 'falied':
            errMsg = '權限不足，請洽管理者。'
            break
          case 'false':
            errMsg = '執行失敗，請洽技術人員。'
            break
          case 'true':
            errMsg = '領取成功。'
            break
          }
          this.$alert(errMsg, '', {
            confirmButtonText: '確定',
            callback: action => {
              // eslint-disable-next-line eqeqeq
              if (res.data.status == 'true') {
                this.getAllData()
                console.log(this)
                this.$emit('updateHeaderCount')
              }
            }
          })
        }).catch(err => {
          loading.close()
          this.$alert('執行失敗，請洽技術人員。', '', {
            confirmButtonText: '確定',
            callback: action => { }
          })
        })
      }, () => {
        loading.close()
        this.$alert('執行失敗，請洽技術人員。', '', {
          confirmButtonText: '確定',
          callback: action => { }
        })
      })
    },
    reSetDefaultValue () { // 重設初始值
      this.postalNoteText = ''
      this.collectionNoteText = ''
      this.oneClickTab = this.$isServiceEnabled(49) ? 'postal' : 'collection'
      this.householdSwitch = false
      this.oneClickDialog = false
      this.tablet = []
      this.postalList = []
      this.postalSelectionList = []
      this.collectionList = []
      this.collectionSelectionList = []
      this.sign = ''
      this.photo = ''
      this.userId = ''
      this.NFCCode = ''
      this.barCode = ''
    },
    filterPackage () {
      this.$refs.reader.getCode((code) => {
        this.$refs.reader.close()
        this.$refs.postalListTable.clearSelection()
        this.postalList.forEach((val, ind) => {
          // eslint-disable-next-line eqeqeq
          if (val.transport_code == code) {
            this.$refs.postalListTable.toggleRowSelection(val)
          }
        })
      }, 'postal')
    },
    // 開啟驗證方式彈窗
    async openMethodSelDialog () {
      this.oneClickTab = this.$isServiceEnabled(49) ? 'postal' : 'collection'
      this.$sendGAEvent('按鈕使用數', {
        value: 'click_快速領取'
      })
      if (this.isCommunityFeaturePermission) { this.methodSelDialog = true }
      try {
        this.signPadAuth = await this.getSignPadAuth() // 確認社區是否開啟簽名板功能
        console.log(this.signPadAuth)
      } catch (e) {
        console.log(e)
      }
    },
    // 關閉快速領取頁面
    closeOneClickDialog () {
      console.log('關閉快速領取頁面')
      this.NFCCode = ''
      this.barCode = ''
    },
    // 新增checkbox disabled 並且顯示tooltip -- start
    initSelections () {
      // 新增row 變數selected
      this.postalList.forEach((row) => {
        row.selected = this.postalSelectionList.includes(row)
      })
    },
    toggleRow (row) {
      if (row.selected) {
        this.$refs.postalListTable.toggleRowSelection(row, true)
      } else {
        this.$refs.postalListTable.toggleRowSelection(row, false)
      }
    },
    postalSelectable (row) {
      // 判斷是否可以勾選包裹
      if (!this.isSmartLockerCommunity) {
        // 非智慧櫃社區皆為可以選擇快速領取包裹
        return true
      } else {
        // 智慧櫃社區 已入櫃不可選取包裹並且顯示通知
        return row.smartLockerStatus !== 2
      }
    },
    // 新增checkbox disabled 並且顯示tooltip -- end
    formatDate (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>

<style lang="sass" scoped>
  .KNS-dialog
    ::v-deep .el-dialog
      +KNSDialog
  .KNSDialogTable
    ::v-deep .el-table
      +KNSDialogTable
      &__header
        th
          font-size: 22px
          background-color: $whiteHover
          color: #5f5f5f
          height: 15px
          width: 6px
          &:first-child .cell
            padding-left: 11px
          .el-checkbox__inner
            width: 30px
            height: 30px
            &:after
              left: 50%
              top: 50%
              height: 15px
              width: 6px
              transform: translate(-50%,-50%) rotate(45deg) scaleY(1)
              border-width: 2px
            &:before
              height: 4px
              top: 11px
      &__body
        tr
          > td
            font-size: 20px
            text-align: center
            color: #2f2f2f
            .tag
              padding: 3px 8px 1px
              border-radius: 0
              font-weight: normal
              font-size: 15px
              vertical-align: 1px
              color: #fff
              margin-left: 5px
              &.refrigeration
                background-color: #009cc4
              &.freezing
                background-color: #007b87
              &.inLocker
                background-color: #26958A
            .serial_num
              font-weight: bold
              font-size: 30px
            .el-checkbox__inner
              width: 30px
              height: 30px
              &:after
                left: 50%
                top: 50%
                height: 15px
                width: 6px
                transform: translate(-50%,-50%) rotate(45deg) scaleY(1)
                border-width: 2px
            .el-checkbox.is-disabled .el-checkbox__inner::after,
            .el-checkbox__input.is-disabled .el-checkbox__inner::after
                content: none
                border: none
  .KNS-OneClick
    +KNS-OneClick
  .fab-button
    background: $warnColor
    border-radius: 100%
    width: 80px
    height: 80px
    position: fixed
    bottom: 135px
    right: 30px
    color: white
    transform: translate3d(0, 0, 0)
    transition: transform ease-out 200ms
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)
    cursor: pointer
    z-index: 20
    &:hover
      transform: scale(1.2, 1.2) translate3d(0, 0, 0)
    &.disabled
      cursor: not-allowed
      background: rgba(220,179,163,1)
    .oc
      height: 100%
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      font-size: 24px
      font-weight: 700
  #methodSelDialog
    ::v-deep .el-dialog__body
      padding: 50px 30px
    .way-select
      img
        width: 160px
        height: 160px
        object-fit: contain
        margin-top: 20px
      h3
        font-weight: bold
        color: #5f5f5f
        font-size: 28px
      ul
        padding: 0 !important
        li
          border-color: #ddd
  .tooltip-content
    font-size: 20px
</style>
